import PageState from "./state"
import mutations from "./mutations"
import { getModule } from '@/store/store'
let APIS = {
  getSpeakerEmotionList: `get /apis/baohuo-yuanchuang/v1/speaker/getSpeakerEmotionList`, // 获取所有发音人风格
  getDefaultSpeaker:`get /apis/baohuo-yuanchuang/speaker/store/search`, //获取默认发音人
  
  getStyleList: `get /apis/baohuo-yuanchuang/migu/video/style/page`,// migu 获取视频风格
  getRandomText: `get /apis/baohuo-yuanchuang/migu/random/text/list`, //随机文案列表
  
  getMiguUser: `get /apis/baohuo-account/v1/user/getMiguUser`, // migu 获取用户信息
  getRights: `get /apis/baohuo-yuanchuang/migu/api/v1/ai-ability/remain-count`, // migu 获取用户权益
  submitCreate: `post /apis/baohuo-yuanchuang/migu/oneClick/article/submit`, // migu 提交一键生成
  getArticleList: `post /apis/baohuo-yuanchuang/migu/oneClick/article/list`, // migu 获取作品列表
  getArticleStatus: `get /apis/baohuo-yuanchuang/migu/oneClick/article/status`, // migu 获取作品状态
  getArticleStatusBatch: `get /apis/baohuo-yuanchuang/migu/oneClick/article/list/status`, // migu 批量获取作品状态

}
export default {
  ...getModule({
    state: new PageState(),
    mutations,
    actions: {},
    APIS,
    name: "miguPage"
  })
}
